import React, { useEffect, useState } from 'react'
import { Button, Popover, MenuItem, Paper, Dialog, DialogTitle, DialogContent, DialogActions, CircularProgress, Table, TableHead, TableRow, TableCell, TableBody, Checkbox } from "@material-ui/core";
import { globalGetService } from '../../../globalServices';
import { checkApiStatus } from '../../utils_v2';
import { STableLoader } from '../../shared_elements';

export default function TitanCustomExport({ onClose, isOpen, majorAssemblyInfo, onTitanCustomExp }) {
    const [isLoading, setLoading] = useState(false)
    const [skeletonLoader, setSkeletonLoader] = useState(false)
    const [customData, setCustomData] = useState([])
    const [selectedItems, setSelectedItems] = useState([])
    const [urlParams, setURLParams] = useState([])

    useEffect(() => {
        getCustomList()
    }, [])
    const getCustomList = () => {
        setSkeletonLoader(true)
        globalGetService(`console/export/user_tech_spec/`)
        .then(response => {
            setSkeletonLoader(false)
                if(checkApiStatus(response)){
                    setCustomData(response.data.data)
                }
            })
    }
    const handleCheckboxChange = (item, type, flag) => {
        let data = Object.assign({},item)
        if(item.checked_modules?.includes(type)){
            data= {...data,
                checked_modules:data.checked_modules.filter(item => item !== type)
            }
        }else{
            data= {...data,
                checked_modules: [...data.checked_modules, type]
            }
        }
        setCustomData(customData.map(items => data.key === items.key ?data: items))
    }
    const handleMACheck =(slug, type)=>{
        let urlItem = `${type}_${slug}`
        if(selectedItems?.includes(slug)){
        setSelectedItems(selectedItems.filter(item => item !==slug))
        setURLParams(urlParams.filter(item=> item !==urlItem) )
        }else{
            setSelectedItems([...selectedItems,slug ])
            setURLParams([...urlParams,urlItem ])
        }
    }
    const onCustomExport =()=>{
        let url =customData.map(item => `${!item?.checked_modules?.length ? '': `${item?.key}=`}${(item?.checked_modules.map(item => `${item}`).join(',') )}`).filter(item => item?.length >0).join('&')
        let maUrl = urlParams.map(item=> `${item}`).join(',')
        let query = `major-assemblies=${maUrl}&${url}`
        onTitanCustomExp(query, 'titanCustom')
        
    }
    return (
        <div>
            <Dialog
                open={isOpen}
                onClose={() => onClose(false)}
                className='console-management-modal'
                maxWidth={'md'}
            >
                <DialogTitle id="scroll-dialog-title">
                    Custom Overview Summary Export
                </DialogTitle>
                <DialogContent dividers={true}>
                    <div className="mui-table-format" style={{ maxHeight: '600px', minWidth:"500px" }}>
                        <ul className='list-inline'>
                            {majorAssemblyInfo?.list?.map((item, index) => (
                                <li className='list-inline-item'>
                                    <Checkbox
                                        color="primary"
                                        size="small"
                                        id={`assembly-${index}`}
                                        name={`assembly-${index}`}
                                        checked={selectedItems?.includes(item?.slug)}
                                        onChange={() => handleMACheck(item?.slug, item?.major_assembly_type.toLowerCase() )}
                                    />
                                    {item?.major_assembly_name || '--'}
                                </li>
                            ))}
                        </ul>
                        {skeletonLoader? <STableLoader count={6}/>:
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Feature/Asset</TableCell>
                                    <TableCell>Aircraft</TableCell>
                                    <TableCell>Engine</TableCell>
                                    <TableCell>Landing Gear</TableCell>
                                    <TableCell>Propeller</TableCell>
                                    <TableCell>APU</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {customData?.map((item, index) => (
                                    <TableRow key={index}>
                                        <TableCell><div style={{marginLeft:item?.align =='right'?'30px':''}}> {item?.name || '--'}</div></TableCell>
                                        {(() => {
                                        const modules = ["aircraft", "engine", "lg", "propeller", "apu"]
                                        return modules.map(type => {
                                                if (item?.modules?.includes(type)) {
                                                    return (
                                                        <TableCell>
                                                            <Checkbox
                                                                color="primary"
                                                                size="small"
                                                                id={`data-${index}`}
                                                                name={`data-${index}`}
                                                                disabled={type =='aircraft' ? false: urlParams?.length >0 ? urlParams?.map(item=> item?.split('_')[0]).includes(type)? false:true :true }
                                                                checked={item?.checked_modules?.includes(type)}
                                                                onChange={(e) => handleCheckboxChange(item, type, e.target.checked)}
                                                            />
                                                        </TableCell>)
                                                } else {
                                                    return <TableCell>
                                                        <div style={{fontSize:'12px', marginLeft:'10px'}}>N/A</div></TableCell>
                                                }
                                            }
                                            )
                                        })()}
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>}
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button disabled={isLoading} onClick={() => { onClose(false); setSelectedItems([]) }} color='primary' size='small' variant='outlined'>Cancel</Button>
                            <Button disabled={ customData.filter(item => item?.checked_modules.includes('aircraft')).length ? false : isLoading || selectedItems.length === 0  } onClick={onCustomExport} color='primary' size='small' variant='contained'>
                                {isLoading ? <CircularProgress size={24} /> : 'Export'}
                            </Button> 
                </DialogActions>

            </Dialog>
        </div>
    )
}
